(function () {
    'use strict';

    angular.module("order")
        .directive('cpPreflightPreviewSimple', cpPreflightPreviewSimple);

    cpPreflightPreviewSimple.$inject = ['$timeout', 'previewModalSrvc'];

    function cpPreflightPreviewSimple($timeout, previewModalSrvc) {

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/order/directives/preflight-preview-simple/preflight-preview-simple.html',
            scope: {
                orderProductFile: '=',
                productKind: '=',
                loading: '='
            },
            link: function (scope, element, attrs, controller) {
                var carousel;

                scope.isMultiPageFile = checkFileType();
                scope.isHorizontal = false;
                scope.currentPage = 0;
                scope.previousPage = 0;
                scope.currentPageObj = scope.orderProductFile.pages[0];
                scope.indexFix = scope.productKind === 'uv' ? 2 : 1;
                scope.pageCount = Math.ceil(scope.orderProductFile.pages.length);

                scope.goToPageNum = {
                    value: null
                };

                scope.fileHasErrors = fileHasErrors;
                scope.changePageOnEnter = changePageOnEnter;
                scope.onPageChange = onPageChange;
                scope.resetPageNum = resetPageNum;
                scope.isUv = isUv;
                scope.currentPageDisplay = currentPageDisplay;
                scope.pageHasErrors = pageHasErrors;
                scope.pageHasWarnings = pageHasWarnings;
                scope.previewImage = previewImage;

                scope.init = function () {
                    scope.loading = false;

                    $timeout(function () {
                        carousel = element.find('#carousel-nav').slick({
                            dots: false,
                            arrows: false,
                            variableWidth: true,
                            centerMode: true,
                            centerPadding: '0',
                            infinite: false,
                            draggable: false,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            asNavFor: '#carousel'
                        });
                        carousel = element.find('#carousel').slick({
                            dots: false,
                            arrows: false,
                            variableWidth: true,
                            centerMode: true,
                            centerPadding: '0',
                            infinite: false,
                            draggable: false,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            asNavFor: '#carousel-nav'
                        });
                    }, 150);

                }; // @end scope.init

                scope.changePage = function (pageNum) {
                    if (scope.currentPage === pageNum) {
                        return;
                    }
                    if (pageNum >= 0 && pageNum <= scope.pageCount - 1) {
                        scope.previousPage = scope.currentPage;
                        scope.currentPage = pageNum;
                        scope.currentPageObj = scope.orderProductFile.pages[pageNum];
                        carousel.slick('slickGoTo', scope.currentPage, true);
                    }
                };

                scope.isFirstPage = function () {
                    return scope.currentPage === 0;
                };

                scope.isLastPage = function () {
                    return scope.currentPage === (scope.pageCount - 1);
                };

                scope.init();

                function checkFileType() {
                    if (scope.productKind === 'uv') {
                        return scope.orderProductFile.pages.length > 4;
                    } else {
                        return scope.orderProductFile.pages.length > 2;
                    }
                }

                function changePageOnEnter($event) {
                    if ($event.which === 13) {
                        scope.changePage(this.goToPageNum.value - 1);
                    }
                }

                function onPageChange() {
                    if (this.goToPageNum.value > scope.pageCount) {
                        this.goToPageNum.value = scope.pageCount;
                    } else if (this.goToPageNum.value < 1) {
                        this.goToPageNum.value = 1;
                    }
                }

                function resetPageNum() {
                    scope.goToPageNum.value = null;
                }

                function fileHasErrors() {
                    return scope.orderProductFile.preflight_status.class === cartPreviewStatusConst.error;
                }

                function isUv() {
                    return scope.productKind === 'uv';
                }


                function currentPageDisplay() {
                    if (isUv()) {
                        var uvPageCount = Math.ceil(scope.orderProductFile.pages.length / scope.indexFix);
                        if (scope.currentPage % 2 === 0) {
                            return ' ' + (scope.currentPage + 1) + '/' + uvPageCount;
                        } else {
                            return ' ' + scope.currentPage + '/' + uvPageCount + ' (uv)';
                        }
                    } else {
                        return ' ' + (scope.currentPage + 1) + '/' + scope.pageCount;
                    }
                }

                function pageHasErrors(currentPage) {
                    var currentPageObj = scope.orderProductFile.pages[currentPage];
                    return currentPageObj.errors;
                }

                function pageHasWarnings(currentPage) {
                    var currentPageObj = scope.orderProductFile.pages[currentPage];
                    return currentPageObj.warnings;
                }

                function previewImage(fileImage) {
                    previewModalSrvc.fileImagePreviewModal(fileImage, angular.noop, angular.noop);
                }
            }
        };
    }
})();
